module.exports = "/packs/media/images/LifeExpectancyChart_WithComment-8307b97f81c6d3e07ac33972e2c8940b.png";